import { HttpParams } from '@angular/common/http';

/** Hintergrund-Refresh für offene Liegeplan-Ansicht (Hafenmeister-Bildschirm). */
export const BERTH_MAP_LIVE_REFRESH_MS = 15_000;

/** Fensterbreite für „Jetzt“ / Live-Modus auf dem Liegeplan. */
export const BERTH_MAP_NOW_WINDOW_MINUTES = 60;

const NOW_RANGE_MINUTE_STEP = 5;

/** Rundet auf volle Minuten und dann auf das Liegeplan-Raster (5 Min.). */
export function floorDateToBerthMapGrid(date: Date): Date {
    const rounded = new Date(date);
    rounded.setSeconds(0, 0);
    const totalMinutes = rounded.getHours() * 60 + rounded.getMinutes();
    const floored = Math.floor(totalMinutes / NOW_RANGE_MINUTE_STEP) * NOW_RANGE_MINUTE_STEP;
    rounded.setHours(Math.floor(floored / 60), floored % 60, 0, 0);
    return rounded;
}

export function getBerthMapElectricMeterCabinetParams(): HttpParams {
    return new HttpParams()
        .set('onlyCurrentAssignments', 'true')
        .set('view', 'map');
}

export function getBerthMapPierParams(): HttpParams {
    return new HttpParams().set('view', 'map');
}
